export const parseNumber = (val = '') => {
  let int;
  try {
    int = parseInt(val, 10);
    if (isNaN(int)) {
      const cleanStr = val.replace(/\D/gim, '');
      int = parseInt(cleanStr, 10);
      if (isNaN(int)) {
        return NaN;
      }
    }
  } catch (error) {
    return NaN;
  }

  if (int <= 0) {
    return 0;
  }
  return int;
};

export const isNumber = val => isNaN(parseNumber(val)) === false;
